import { css } from '@emotion/react';

import { typography2 } from '@coursera/cds-core';
import type { Theme } from '@coursera/cds-core';

const comboBoxStyles = {
  cont: css`
    flex: 1;
    position: relative;
    display: flex;
  `,
  toggleButton: (_: Theme, width?: string) => css`
    flex: 1;
    display: flex;
    gap: 10px;
    justify-content: space-between;
    align-items: center;
    padding: var(--cds-spacing-150);
    color: var(--cds-color-grey-700);
    background: var(--cds-color-white-0);
    border: 1px solid var(--cds-color-grey-600);
    border-radius: 4px;

    &:hover {
      border-color: var(--cds-color-blue-800);
      background: var(--cds-color-blue-25);
    }

    ${width
      ? css`
          max-width: ${width};
          width: ${width};
        `
      : `
    max-width: 400px;
  `}

    .button-clear {
      background: none;
      padding: 0;
      border: 0;
      height: 20px;
      width: 20px;
    }
  `,
  portal: (position: { x: number; y: number; width: number }) => css`
    position: absolute;
    top: ${position.y}px;
    left: ${position.x}px;
    width: ${position.width}px;
    z-index: 10200;
  `,
  popover: () => css`
    border: 1px solid var(--cds-color-blue-800);
    border-radius: 4px;
    margin-top: var(--cds-spacing-150);
    background: #fff;

    .combobox-info {
      padding: var(--cds-spacing-50) var(--cds-spacing-300);
      user-select: none;
      ${typography2.bodyPrimary}
    }
  `,
  clickLayer: (_: Theme, width?: string) => css`
    ${width
      ? css`
          max-width: ${width};
          width: ${width};
        `
      : `
    max-width: 400px;
  `}
    height: 50px;
    display: flex;
    align-items: start;
    padding: var(--cds-spacing-150);
    border: 1px solid transparent;
  `,
  input: () => css`
    flex: 1;
    display: block;
    background: none;
    border: 0;
    outline: none;
    padding: 0;
    ${typography2.bodyPrimary}
  `,
  clearButton: css`
    width: 40px;
    height: 100%;
    cursor: pointer;
  `,
  results: () => css`
    max-height: 280px;
    overflow-y: scroll;
    padding: var(--cds-spacing-150) 0;
  `,
  item: () => css`
    padding: 0 var(--cds-spacing-200);
    display: flex;
    align-items: center;
    gap: 5px;
    font-weight: normal;
    cursor: pointer;
    color: #333;

    &.menu-item-active,
    &:active {
      background: transparent;
    }
  `,
  backdrop: css`
    .combobox-backdrop {
      position: fixed;
      inset: 0;
      z-index: 10050;
    }
  `,
  sectionHeaders: () => css`
    margin-left: var(--cds-spacing-300);
    margin-bottom: var(--cds-spacing-100);
  `,
  sectionDivider: () => css`
    margin: var(--cds-spacing-300);
    margin-top: var(--cds-spacing-200);
  `,
  errorMessage: () => css`
    background-color: var(--cds-color-red-25);
    padding: var(--cds-spacing-50) var(--cds-spacing-100);
    border-radius: 4px;
    margin-bottom: var(--cds-spacing-150);
  `,
  warningIcon: () => css`
    margin-right: var(--cds-spacing-100);
  `,
};

export default comboBoxStyles;
